<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="changeOrderState"
               @close="$emit('close')"
  >
    <order-state-combobox v-model="state" :input-errors="inputErrors"></order-state-combobox>
  </crud-update>
</template>

<script>

import OrderProvider from "../../../../providers/OrderProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import OrderStateCombobox from "@/modules/delivery/combobox/OrderStateCombobox/OrderStateCombobox";


export default {
  name: "OrderUpdateState",

  components: {OrderStateCombobox,  CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.orderSystem.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      state: this.item.state,
    }
  },
  methods: {
    changeOrderState() {
      this.loading = true
      OrderProvider.updateOrderState({
        id: this.id,
        state: this.state
      })
          .then(() => {
            this.$emit('itemUpdated')
            this.$emit('close')
          })
          .catch(error => {
            console.error(error)
            let clientError = new ClientError(error)
            this.inputErrors = clientError.inputErrors
            this.errorMessage = clientError.i18nMessage
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
  ,
}
</script>

<style scoped>

</style>

